"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _component = require("../base/component");

var _icon = _interopRequireDefault(require("../icon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var Tag = function Tag(props) {
  var _classNames;

  var _useState = (0, React.useState)(props.active),
      _useState2 = _slicedToArray(_useState, 2),
      stateActive = _useState2[0],
      setStateActive = _useState2[1];

  var _useState3 = (0, React.useState)(props.active),
      _useState4 = _slicedToArray(_useState3, 2),
      preActive = _useState4[0],
      setStatePreActive = _useState4[1]; // https://reactjs.org/docs/hooks-faq.html#how-do-i-implement-getderivedstatefromprops


  if (preActive !== props.active && props.control) {
    setStateActive(props.active);
    setStatePreActive(props.active);
  }

  var clsPrefix = 'kui-tag';
  var className = props.className,
      style = props.style,
      multi = props.multi,
      disabled = props.disabled,
      showOnly = props.showOnly,
      removeAble = props.removeAble,
      label = props.label;
  var cls = (0, _classnames["default"])(clsPrefix, (_classNames = {}, _defineProperty(_classNames, "".concat(clsPrefix, "-active"), stateActive), _defineProperty(_classNames, "".concat(clsPrefix, "-multi"), multi), _defineProperty(_classNames, "".concat(clsPrefix, "-disabled"), disabled), _defineProperty(_classNames, "".concat(clsPrefix, "-showOnly"), showOnly), _defineProperty(_classNames, "".concat(clsPrefix, "-removeAble"), removeAble), _classNames), className);

  var handleClick = function handleClick() {
    var _props$onChange;

    if (!props.control) {
      setStateActive(!stateActive);
    }

    (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, {
      value: props.value,
      label: props.label
    });
  };

  var handleRemove = function handleRemove(event) {
    if (props.removeAble && props.onRemove) {
      props.onRemove({
        value: props.value,
        label: props.label
      });
    }

    event.stopPropagation();
  };

  return /*#__PURE__*/React.createElement("span", {
    className: cls,
    style: style,
    onClick: handleClick
  }, label, multi && stateActive ? /*#__PURE__*/React.createElement(_icon["default"], {
    type: "check"
  }) : '', props.removeAble ? /*#__PURE__*/React.createElement(_icon["default"], {
    type: "close",
    onClick: handleRemove
  }) : '');
};

Tag.defaultProps = _objectSpread(_objectSpread({}, _component.baseDefaultProps), {}, {
  value: 0,
  // id
  label: 'Tag',
  // tag标签
  active: undefined,
  // 是否激活
  multi: false,
  // 多/单选
  disabled: false,
  // 是否禁用
  showOnly: false,
  // 是否为展示标签
  removeAble: false,
  // 是否可以删除
  onChange: null,
  onRemove: null,
  control: true
});
var _default = Tag;
exports["default"] = _default;